<template>
  <div style="width: 100%; overflow-x: auto; padding-top: 25px;">
    <template v-if='statusGeral !== ""'>
      <RF-Status :cpntStatus='statusGeral' :cpntTamanho='5'></RF-Status>
    </template>

    <template v-else-if='statusGeral === "" && Object.keys(tabela).length >= 1'>
      <template v-if='$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(true, [ 15 ], null, [ 25 ], null, [ 536 ], null, false) === true'>
        <!-- LOCAL AONDE SERÁ ABERTO O FORMULARIO -->
        <transition name="rf-anima-mask" v-if='Object.keys(buttonForm).length > 0'>
          <router-view 
            @RefreshTabela='iniciarTabela(null, null)'
            @onUpdateCategoria='iniciar'
          ></router-view>
        </transition>

        <!-- BOTÃO INSERIR -->
        <div v-if='Object.keys(buttonForm).length > 0' style="float: left; margin-right: 30px;">
          <RF-Button 
            :cpntId='tabela.id + "-" + buttonForm.id'
            :cpntStatus='buttonForm.status' 
            :cpntTexto='buttonForm.texto' 
            :cpntClass='buttonForm.class' 

            @onClickButton='$router.push({ name: "servico_config_categoria_form", params: { id: 0 } })'
          ></RF-Button>
        </div>
      </template>

      <RF-Filtro-Busca-Telas v-if='Object.keys(filtros).length >= 1'
        :cpntTime='time'
        :cpntStatus='tabela.status'
        :cpntField='filtros'

        :cpntOnRealizaBusca='iniciarTabela'
        :ref='tabela.id + "-filtro"'
      ></RF-Filtro-Busca-Telas>
      <!-- INFORMAÇÕES RELACIONADAS A TABELA -->
      <!-- <div style="float: right;" v-if='filtro.hasOwnProperty("busca") && Object.keys(filtro.busca).length >= 1'>

        <div class='rf-filtro-tela' v-if='Object.keys(filtro.busca).length > 0'>
          <div class="input-group margin-bottom-sm">
            <input 
              ref='input-busca' 
              class="form-control" 
              type="text" 
              :placeholder="filtro.busca.placeholder" 
              :autofocus="filtro.busca.autofocus" 
              @keyup.enter='iniciarTabela(null, null)' 
              v-model='filtro.busca.value'>
            <span class="input-group-addon" style="cursor: pointer;" @click='iniciarTabela(null, null)'>
              <i class="fa fa-search"></i>
            </span>
          </div>
        </div>
      </div> -->

      <!-- CRIA A TABELA -->
      <div style="clear: both; padding-top: 10px;">
        <RF-Tabela :data-time='time' style='overflow-x: auto;'
          :cpntTime='time'
          :cpntId='tabela.id'
          :cpntStatus='tabela.status'
          :cpntButtonImprimir='tabela.acoes.btImprimir'
          :cpntButtonAtualizar='tabela.acoes.btAtualizar'
          :cpntFraseTop='tabela.fraseTop'
          :cpntColuna='tabela.coluna'
          :cpntLinha='tabela.linha'
          :cpntCountAll='tabela.countAll'
          :cpntColspan='tabela.colspan'
          :cpntButtonsAcoes='tabela.acoes.buttons'
          :cpntMper='tabela.mper'
          :cpntPagina='tabela.pagina'
          :cpntCheckboxEditar='tabela.checkboxEditar'
          :cpntFieldsEditar='tabela.acoes.fields'

          :cpntOnRefreshTabela='iniciarTabela'
          :cpntOnCheckboxAtualiza='onCheckboxAtualiza'

          :ref='tabela.id'
        ></RF-Tabela>
      </div>
    </template>
  </div>
</template>

<style socped>
  /* CONFIGURAÇÕES DOS FILTROS DA TELA */
  /* -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= */
  .rf-tabela-filtro-tela > .rf-filtro-tela-busca {
    width: 450px;
  }
</style>

<script>
  export default {
    components: {
      'RF-Select2': () => import('@/components/rf-geral/select2/RF-Select2.vue'),
      'RF-Filtro-Busca-Telas': () => import('@/components/rf-geral/busca/RF-Busca-Telas.vue')
    },
    data: function () {
      return {
        time: '',
        statusGeral: '',
        tabela: {},
        checkbox: [],
        formDataTab: [],
        buttonForm: {},

        filtros: {}
      }
    },
    mounted: function () {
      this.iniciar()
    },
    methods: {
      // FUNÇOES ATUALIZADA PARA TELA
      // =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
      iniciar: function () {
        var self = this

        self.time = ''
        self.statusGeral = ''
        self.tabela = {}
        self.checkbox = []
        self.allCategoria = []
        self.formDataTab = []
        self.filtros = {}

        // SETA O STATUS PARA TABELA
        self.statusGeral = 'carregando'

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        self.time = new Date().getTime()

        // VERIFICA SE TEM A PERMISSÃO NOVO SERVIÇO
        if (self.$store.state.token.clu_mu === 'a' || self.$store.state.token.clu_pu.indexOf(533) !== -1) {
          // CRIA O FILTRO DE CATEGORIA
          self.buttonForm = {
            status: '',
            id: 'button-form',
            texto: 'Nova Categoria de Serviço',
            class: [ 'btn', 'btn-info', 'btn-md' ]
          }
        }

        // CRIA O FILTRO DE CATEGORIA
        self.filtros = {
          busca: {
            tipo: 'input-busca',
            id: 'servico-config-busca',
            tamanho: 3,
            value: '',
            placeholder: 'Digite sua pesquisa'
          }
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        self.time = new Date().getTime()

        // CRIA AS CHAVES PADROES DE TODOS OS COMPONENTS
        self.$store.state.FUN_CREATE_KEY_FIELDS(self.filtros, function (fields) {
          // SETA OS VALORES RECEBIDOS
          self.filtros = fields

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()

          // BUSCA AS CATEGORIAS
          self.iniciarTabela()
        })
      },

      // FUNÇÕES REFERENTE A TABELA
      // -=-=--=-=--=-=--=-=--=-=--=-=--=-=--=-=--=-=--=-=--=-=--=-=--=-=--=-=-
      iniciarTabela: function (pag = null, rpp = null) {
        var self = this

        // SETA O STATUS PARA TABELA
        self.statusGeral = ''

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        self.time = new Date().getTime()

        // LIMPA OS CAMPOS PARA SEREM INICIANDO NOVAMENTE
        self.tabela = {
          status: 'carregando',
          id: 'tab-ser',
          api: {
            router: '/servico/categoria/get/',
            model: 'SerCat',
            where: { aAnd: [ { f: 'status', o: '=', v: 1 } ] }
          },
          acoes: {
            buttons: [
              { tipo: 'editar', class: 'btn btn-warning btn-sm', tipoEditar: { 'individual': null, 'geral': self.onAbrirFormulario }, onClick: self.servicoConfigModificar },
              { tipo: 'excluir', class: 'btn btn-danger btn-sm', onClick: self.onDeleteRegistro }
            ],
            fields: {}
          },
          mper: {
            field: true,
            rpp: true,
            order: '0',
            orderField: [ { last_at: 'desc' }, { id: 'asc' }, { nome: 'asc' }, { id: 'desc' } ]
          }
        }

        if (self.filtros.busca.value !== '' && self.filtros.busca.value.substring(0, 1).toUpperCase() === 'C' && isNaN(self.filtros.busca.value.substring(1, self.filtros.busca.value.length)) === false) {
          self.tabela.api.where.aAnd.push({ f: 'id', o: '=', v: self.filtros.busca.value.substring(1, self.filtros.busca.value.length) })
        } else if (self.filtros.busca.value !== '') { // ADICIONA NA PESQUISA O INPUT BUSCA
          self.tabela.api.where.aAnd.push({ o: 's.ft', v: self.filtros.busca.value })
        }

        if (pag !== null && rpp !== null) {
          self.tabela.pagina = { num: pag.toString(), rpp: rpp.toString() }
        }

        // INFORMA TODAS AS COLUNAS DA TABELA
        self.tabela.colunaAll = [
          { mPer: 3, tipo: 'RF-Checkbox', chave: 'id' },
          { mPer: 2, chave: 'id', nome: 'Cod.', fieldApi: { id: null } },
          { mPer: 2, chave: 'nome', nome: 'Nome', fieldApi: { nome: null } },
          { mPer: 1, chave: 'rf-ult-alt', nome: 'Última Alteração', fieldApi: { last_at: null, last_user: { j: { usuario: null } } } }
        ]

        // CRIA O CAMPO NOME NO FORMULARIO
        self.tabela.acoes.fields = {
          'nome': [
            {
              tamanho: 3,
              tipo: 'input',
              apiEnv: 'nome',
              apiRec: 'nome',
              onChange: self.onChangeValueTabela
            }
          ]
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        self.time = new Date().getTime()

        // FAZ A MONTAGEM DAS INFORMAÇÕES PARA TABELA
        self.$store.state.FUN_TABELA_CRIAR_DADOS(self.tabela, function (tabelaSuccess) {
          // SETA OS DADOS RECEBIDOS PARA TABELA
          self.tabela = tabelaSuccess

          // REALIZA O FOR PARA CRIAR OS CAMPOS PERSONALIZADOS
          for (var key in self.tabela.linha) {
            if (self.tabela.linha[key].hasOwnProperty('last_user')) {
              self.tabela.linha[key]['rf-ult-alt'] = [ self.tabela.linha[key]['last_user_usuario'] + '<br/>' + self.tabela.linha[key]['last_at_ptbr'] ]
            }
          }

          // SETA O STATUS
          self.tabela.status = ''

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()

          // SETA O FOCUS NO CAMPO BUSCA
          self.servicoConfigCategoriaFormOnFocusCampo(self.tabela.id + '-filtro', 'input-busca')

          // setTimeout(function () {
          //   // VERIFICA SE NÃO ESTA COM O FORMULARIO ABERTO
          //   if (self.$route.hasOwnProperty('name') && self.$route.name === 'serv_gere') {
          //     self.$refs['input-busca'].select() // SETA O FOCUS NO CAMPO
          //   }
          // }, 200)
        }, function (tabelaError) {
          // SETA OS DADOS RECEBIDOS PARA TABELA
          self.tabela.status = tabelaError

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()
        })
      },
      servicoConfigCategoriaFormOnFocusCampo: function (campo = null, field = null, scroll = false, tentativa = 0) {
        if ([ '', null, undefined ].indexOf(campo) === -1) {
          var self = this

          setTimeout(function () {
            if ([ '', null, undefined ].indexOf(self.$refs[campo]) === -1 && [ '', null, undefined ].indexOf(self.$refs[campo].realizarFocusNoCampo) === -1) {
              self.$refs[campo].realizarFocusNoCampo(field)
            } else if (tentativa <= 10) {
              self.servicoConfigCategoriaFormOnFocusCampo(campo, field, scroll, (tentativa + 1))
            }
          }, (tentativa === 0 ? 0 : 200))
        }
      },
      onCheckboxAtualiza: function (coluna = null, checkbox = null) {
        if (coluna !== null && checkbox !== null) {
          var self = this
          var indexColuna = self.tabela.coluna.findIndex(item => item.chave === coluna)

          self.checkbox[coluna] = checkbox.filter(item => item !== self.tabela.coluna[indexColuna].chave)
        }
      },
      onChangeValueTabela: function (value, id) {
        // PEGA O NOME DO CAMPO QUE ESTA SENDO ALTERADO
        var index = id.split('--')

        // SETA O VALOR RECEBIDO
        this.tabela.linha[index[1]][index[2]][index[3]].value = value

        // REMOVE A MENSAGEM DE ERRO
        this.tabela.linha[index[1]][index[2]][index[3]].mensagem = ''
        this.tabela.linha[index[1]][index[2]][index[3]].mensagemTipo = ''

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      servicoConfigModificar: function () {
        var self = this

        self.$store.state.FUN_CREATE_FORM_API_TABELA(self.tabela.linha, self.checkbox.id, {}, function (formDataTab) {
          // REMOVE A CHAVE ID QUE NÃO SERÁ UTILIZADA
          for (var key in formDataTab) {
            delete formDataTab[key].id
          }

          // CHAMA A FUNÇÃO PARA COMUNICAR COM A API
          self.servicoConfigcmunicaPutTab(formDataTab)
        })
      },
      servicoConfigcmunicaPutTab: function (formDataTab) {
        var self = this

        // VERIFICA SE TEM ALGUM FORMULARIO PARA COMUNICAR
        if (formDataTab.length >= 1) {
          self.$store.state.comunicaAPI('/servico/categoria', 'PUT', formDataTab[0], function () {
            // REMOVE O FORMULARIO TRANSMITIDO
            formDataTab.splice(0, 1)

            // SETA O TIME PARA FORÇA A ATUALIZAÇÃO DO COMPONENT
            self.time = new Date().getTime()

            // CHAMA A FUNÇÃO PARA CONTINUAR A COMUNICAÇÃO
            self.servicoConfigcmunicaPutTab(formDataTab)
          }, function (apiError) {
            // SETA O ERRO RECEBIDO
            self.tabela.status = apiError

            // SETA O TIME PARA FORÇA A ATUALIZAÇÃO DO COMPONENT
            self.time = new Date().getTime()
          }, function (apiValid, apiStatus) {
            self.$store.state.FUN_API_RET_VALIDA_TABELA(apiValid, apiStatus, self.tabela.linha, true, function (linha) {
              // SETA OS CAMPOS COM OS ERROS
              self.tabela.linha = linha

              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              self.time = new Date().getTime()
            })
          })
        } else {
          self.$store.state.msgWarn('WEB [200]: Categoria(s) de Serviço alterada com sucesso.', 'success')

          // FORÇA A ATUALIZAÇÃO DOS COMPONENTS
          self.time = new Date().getTime()

          // CHAMA A FUNÇÃO PARA ATUALIZAR OS TOTAIS DA VENDA
          self.iniciar()
        }
      },
      onDeleteRegistro: function () {
        if (window.confirm('Deseja realmente excluir a(s) categorias de serviço(s) selecionadas?')) {
          var self = this

          // SETA O STATUS DE CARREGANDO PARA O BOTÃO
          self.tabela.acoes.buttons[1].status = 'carregando'

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()

          // CRIA O FORMUARIO QUE SERÁ ENVIADO PARA API
          var formData = { j_id: JSON.stringify(self.checkbox.id) }

          // CHAMA FUNÇÃO PARA COMUNICAR COM API
          self.$store.state.comunicaAPI('/servico/categoria', 'DELETE', formData, function (apiSuccess) {
            self.$store.state.TRATAR_RET_LOT_API(apiSuccess, function () {
              // SETA O TIME PARA FORÇA A ATUALIZAÇÃO DO COMPONENT
              self.time = new Date().getTime()

              // CHAMA A FUNÇÃO PARA ATUALIZAR OS TOTAIS DA VENDA
              self.iniciar()
            }, 'WEB [200]: Registros excluídos com sucesso.')
          }, function (apiError) {
            // SETA O STATUS DE CARREGANDO PARA O BOTÃO
            self.tabela.acoes.buttons[1].status = ''

            // ALTERA O STATUS
            self.tabela.status = apiError

            // SETA O TIME PARA FORÇA A ATUALIZAÇÃO DO COMPONENT
            self.time = new Date().getTime()
          })
        }
      }
    }
  }
</script>
